export const home = {
  status_data: {},
  table_data: null,
  is_table_loading: false,
  is_login_loading: false,
  item_rows: [],
  searchPdbShipRef: "",
  searchPetcoShipRef: "",
  user: {},
  user_role: "",
  expanded: false,
  is_panel_loading: false,
  expansion_data: {},
  currentExpandRowIndex: 0
};



// WEBPACK FOOTER //
// ./src/reducers/home/home.state.js